import { render, staticRenderFns } from "./vertical-keyword.component.html?vue&type=template&id=ee23cb1a&scoped=true&external"
import script from "./vertical-keyword.component.vue?vue&type=script&lang=ts"
export * from "./vertical-keyword.component.vue?vue&type=script&lang=ts"
import style0 from "./vertical-keyword.component.css?vue&type=style&index=0&id=ee23cb1a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee23cb1a",
  null
  
)

export default component.exports